import { render, staticRenderFns } from "./AlertDismissible.vue?vue&type=template&id=777f7c68"
import script from "./AlertDismissible.vue?vue&type=script&lang=js"
export * from "./AlertDismissible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports